// Standard Latin alphabet used by most languages
const LATIN_ALPHABET = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
];
// Relative frequencies for the **first letter of words** in English, not how often each letter
// appears in running text. (Sums to 100.) For corpus-wide English letter counts, see
// https://norvig.com/mayzner.html (Google Books n-grams).
const EN_WEIGHTS = [
    9.0, // A
    3.8, // B
    7.5, // C
    3.8, // D
    2.8, // E
    3.3, // F
    2.8, // G
    3.3, // H
    3.8, // I
    1.4, // J
    1.9, // K
    3.8, // L
    5.2, // M
    2.8, // N
    3.3, // O
    8.5, // P
    1.1, // Q
    5.8, // R
    9.4, // S
    6.6, // T
    1.7, // U
    2.1, // V
    2.8, // W
    0.9, // X
    1.4, // Y
    1.2, // Z
];
// Same idea as EN_WEIGHTS: **word-initial** (first-letter) weighting for Spanish, not intra-word frequency.
const ES_WEIGHTS = [
    8.0, // A
    4.5, // B
    8.5, // C
    4.5, // D
    6.0, // E
    2.5, // F
    2.5, // G
    3.5, // H
    3.0, // I
    2.2, // J
    0.1, // K
    4.5, // L
    5.5, // M
    3.0, // N
    3.5, // O
    8.0, // P
    3.0, // Q
    5.5, // R
    9.0, // S
    5.0, // T
    1.5, // U
    3.5, // V
    0.1, // W
    0.3, // X
    1.2, // Y
    1.1, // Z
];
export const languages = [
    {
        value: 'en',
        label: 'English',
        disabled: false,
        accents: [
            {
                value: 'en-US',
                label: 'American',
                disabled: false,
            },
            {
                value: 'en-AU',
                label: 'Australian',
                disabled: false,
            },
            {
                value: 'en-GB',
                label: 'British',
                disabled: false,
            },
            {
                value: 'en-IN',
                label: 'Indian',
                disabled: false,
            },
        ],
        alphabet: LATIN_ALPHABET,
        alphabetWeights: EN_WEIGHTS,
    },
    {
        value: 'de',
        label: 'Deutsch (bald verfügbar)',
        disabled: true,
        accents: [
            {
                value: 'de-DE',
                label: 'Deutsch',
                disabled: true,
            },
        ],
        alphabet: LATIN_ALPHABET,
        alphabetWeights: EN_WEIGHTS,
    },
    {
        value: 'es',
        label: 'Español (próximamente)',
        disabled: true,
        accents: [
            {
                value: 'es-ES',
                label: 'Español de España',
                disabled: true,
            },
            {
                value: 'es-US',
                label: 'Español de América',
                disabled: true,
            },
        ],
        alphabet: LATIN_ALPHABET,
        alphabetWeights: ES_WEIGHTS,
    },
    {
        value: 'fr',
        label: 'Français (à venir)',
        disabled: true,
        accents: [
            {
                value: 'fr-FR',
                label: 'Français de France',
                disabled: true,
            },
            {
                value: 'fr-CA',
                label: 'Français Canadien',
                disabled: true,
            },
        ],
        alphabet: LATIN_ALPHABET,
        alphabetWeights: EN_WEIGHTS,
    },
    {
        value: 'it',
        label: 'Italiano (prossimamente)',
        disabled: true,
        accents: [
            {
                value: 'it-IT',
                label: 'Italiano',
                disabled: true,
            },
        ],
        alphabet: LATIN_ALPHABET,
        alphabetWeights: EN_WEIGHTS,
    },
    {
        value: 'nl',
        label: 'Nederlands (binnenkort)',
        disabled: true,
        accents: [
            {
                value: 'nl-NL',
                label: 'Nederlands',
                disabled: true,
            },
        ],
        alphabet: LATIN_ALPHABET,
        alphabetWeights: EN_WEIGHTS,
    },
    {
        value: 'id',
        label: 'Bahasa Indonesia (segera hadir)',
        disabled: true,
        accents: [
            {
                value: 'id-ID',
                label: 'Bahasa Indonesia',
                disabled: true,
            },
        ],
        alphabet: LATIN_ALPHABET,
        alphabetWeights: EN_WEIGHTS,
    },
];
//# sourceMappingURL=languages.js.map